// extracted by css-extract-rspack-plugin
export default {"cls1":"TransactionalPricingModal-cls1_JqK","cls2":"TransactionalPricingModal-cls2_27m TransactionalPricingModal-cls1_JqK"};